import { Injectable } from '@angular/core';
import { catchError, EMPTY, finalize, Observable, throwError } from 'rxjs';
import { ReferralApiService } from './referral-api.service';
import { ReferralStorageService } from './referral-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralConnectionService {
  private _pendingReferralConnection = false;

  constructor(
    private _referralStorage: ReferralStorageService,
    private _referralApi: ReferralApiService,
  ) {
  }

  public connectToPartner(isFromReg = false): Observable<void> {
    if (this._pendingReferralConnection) {
      return EMPTY;
    }

    const params = this._referralStorage.load();
    if (!params) {
      return EMPTY;
    }

    this._pendingReferralConnection = true;

    const connect = params.isOldPartnership
      ? this._referralApi.connectToPartnerWithLegacyParams
      : this._referralApi.connectToPartner;

    return connect({
      registration: isFromReg,
      referralLinkId: params.ibl!,
      partnerUserId: params.ibp!,
      partnerKey: params.ibk!,
    })
      .pipe(
        catchError(error => {
          if (error?.status === 422) {
            return EMPTY;
          } else {
            return throwError(error);
          }
        }),
        finalize(() => {
          this._pendingReferralConnection = false;
          this._referralStorage.clearAllReferralDataFromStorage();
        }));
  }
}

